import React, { useCallback } from 'react';
import AkEmptyState from '@atlaskit/empty-state';
import { type WrappedComponentProps } from 'react-intl-next';
import messages from './messages';
import playButtonPagesIcon from '../../view/empty-state/icons/play-button-pages.svg';
import Button from '@atlaskit/button/new';
import { type BaseEmptyStateProps } from './types';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useCreateEmbeddedPage } from '../../containers/embedded-page/utils';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

const BaseEmptyState = ({
	intl: { formatMessage },
	spaceKey,
	contentId,
	description,
	primaryActionMessage,
	pageContent = undefined,
	secondaryAction = null,
	projectId,
	projectType,
}: WrappedComponentProps & BaseEmptyStateProps) => {
	const createEmbeddedPage = useCreateEmbeddedPage({
		spaceKey,
		projectId,
		projectType,
	});
	const handleClick = useCallback(
		async (_: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'confluencePageTreeEmptyStateCreateButton');
			await createEmbeddedPage(contentId || undefined, true, undefined, pageContent);
		},
		[contentId, pageContent, createEmbeddedPage],
	);

	return (
		<AkEmptyState
			imageUrl={playButtonPagesIcon}
			imageWidth={160}
			description={formatMessage(description)}
			header={formatMessage(messages.title)}
			primaryAction={
				<Button
					appearance="primary"
					onClick={handleClick}
					testId="confluence-project-pages.empty-state.create-page-button"
				>
					{formatMessage(primaryActionMessage)}
				</Button>
			}
			secondaryAction={secondaryAction}
		/>
	);
};

export default BaseEmptyState;
